import React, { useMemo } from "react";

import { getEnvironment, useTranslation } from "utils";

import { COUNTRY_CODE, MARKETS } from "consts";

import { AddressForm, Col, Form, Input, InputMasked, InputNumber, Option, Row, Select } from "components";

export const ConfirmAccountStep2 = () => {
  const { t } = useTranslation(["signinup", "enums"]);
  const env = getEnvironment();
  const form = Form.useFormInstance();
  const countryCode = Form.useWatch("country", form);

  const countryCodes = useMemo(
    () => (env.production ? Object.values(MARKETS).filter((countryCode) => countryCode !== MARKETS.US) : Object.values(MARKETS)),
    [env.production]
  );

  const handleCountryChange = () => {
    form.setFieldsValue({ region: null });
  };

  return (
    <>
      <Row>
        <Col>
          <h2>{t("confirm.farmDetails.title")}</h2>
          <p className="paragraph-m">{t("confirm.farmDetails.description")}</p>
        </Col>
      </Row>
      <Row className="margin-top-250">
        <Col>
          <Input dataTestId="confirm-farm-name-input" name="farmName" label={t("confirm.inputs.farmName")} rules={[{ required: true }]} />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputNumber
            dataTestId="confirm-total-farm-size-input"
            name="totalFarmSize"
            label={t("confirm.inputs.totalFarmSize")}
            rules={[{ required: true }]}
            precision={2}
            step={0.01}
            min={0}
            suffix="ha"
          />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* @ts-expect-error convert to TS */}
          <Select
            dataTestId="confirm-country-select"
            name="country"
            label={t("confirm.inputs.selectCountry")}
            showSearch
            optionFilterProp="children"
            filterOption={(input: string, option: { children: string }) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            rules={[{ required: true }]}
            onChange={handleCountryChange}
          >
            {countryCodes.map((countryCode, i) => (
              <Option data-testid={`confirm-country-select-option-${i}`} value={countryCode} key={countryCode}>
                {t(`enums:countries.${countryCode}`)}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>

      <Row className="margin-top-200">
        <Col className="padding-0">
          <AddressForm dataTestId="confirm-account" address={null} countryCode={countryCode as COUNTRY_CODE} />
        </Col>
      </Row>

      <Row className="margin-top-200">
        <Col>
          {/* @ts-expect-error convert to TS */}
          <InputMasked dataTestId="confirm-phone-input" name="phone" label={t("confirm.inputs.phone")} rules={[{ required: true }]} mask="+00 00 000000[000]" />
        </Col>
      </Row>
    </>
  );
};
